import type { MutableRefObject } from "react";

import { translate } from "app/filters/i18nFilter";
import { getRecentItems } from "app/pages/activation/helpers/getRecentItems";
import { AutocompleteWebsitesWithKeysControl } from "app/pages/activation/components/Shared/AutocompleteWebsitesWithKeysControl/AutocompleteWebsitesWithKeysControl";

import { CompetitorsStepKeys } from "../../dataAutomationKeys";
import { COMPETITORS_WRAPPER_ID } from "../constants";
import { competitorsStepTexts } from "../texts";
import type { CompetitorSchema } from "../types";

import {
    AI_COMPETITORS_DROPDOWN_Z_INDEX,
    AI_COMPETITORS_DROPDOWN_WIDTH,
    AI_COMPETITORS_DROPDOWN_HEIGHT,
    AI_COMPETITORS_DROPDOWN_SCROLL_HEIGHT,
} from "./constants";
import * as SC from "./styles";
import { COMPETITORS_DROPDOWN_BUTTON_TEXT } from "./texts";

type CompetitorsDropdownSchema = {
    isDisabled: boolean;
    onCompetitorAdd: (competitor: CompetitorSchema) => void;
    onPaste: (e: ClipboardEvent) => void;
    excludedCompetitors: string[];
    autocompleteRef: MutableRefObject<HTMLDivElement | null>;
};

export const CompetitorsDropdown = ({
    isDisabled,
    onCompetitorAdd,
    onPaste,
    excludedCompetitors,
    autocompleteRef,
}: CompetitorsDropdownSchema) => {
    const recent = () => getRecentItems(excludedCompetitors);

    const handleCompetitorSelect = (competitor: CompetitorSchema) => {
        onCompetitorAdd(competitor);
    };

    return (
        <>
            <SC.GlobalPopupStyles />
            <AutocompleteWebsitesWithKeysControl
                popupRef={(ref) => (autocompleteRef.current = ref)}
                ref={autocompleteRef}
                placeholder={translate(competitorsStepTexts.autocompletePlaceholder)}
                onItemClick={handleCompetitorSelect}
                renderOnEmptyQuery={recent}
                exclude={excludedCompetitors}
                className={CompetitorsStepKeys.autocomplete}
                searchIcon="search"
                disabled={isDisabled}
                onPaste={onPaste}
                autoFocus
                zIndex={AI_COMPETITORS_DROPDOWN_Z_INDEX}
                addPopUpOption
                dropdownPopupMinScrollHeight={AI_COMPETITORS_DROPDOWN_SCROLL_HEIGHT}
                scrollAreaMinHeight={AI_COMPETITORS_DROPDOWN_SCROLL_HEIGHT}
                closeOnItemClick
                height={`${AI_COMPETITORS_DROPDOWN_SCROLL_HEIGHT}px`}
                popupButton={
                    <SC.StyledIConButton
                        iconName="search"
                        type="flat"
                        isDisabled={isDisabled}
                    >
                        {translate(COMPETITORS_DROPDOWN_BUTTON_TEXT)}
                    </SC.StyledIConButton>
                }
                popupAppendTo={`#${COMPETITORS_WRAPPER_ID}`}
                popupConfig={{
                    defaultOpen: false,
                    enabled: !isDisabled,
                    width: AI_COMPETITORS_DROPDOWN_WIDTH,
                    height: AI_COMPETITORS_DROPDOWN_HEIGHT,
                    placement: "bottom-right",
                    //@ts-ignore
                    cssClass: "activation_setup_modal_popup_styles",
                    cssClassContent: "activation_setup_modal_popup_content_styles",
                }}
            />
        </>
    );
};
